import MobileBiasModal from './MobileBiasModal';

export default MobileBiasModal;
